import React from 'react'
import ShowExpenses from '../components/expenses/ShowExpenses'
import { useTranslation } from 'react-i18next'

const Expenses: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className='mt-20'>
      <h1  className='text-center text-3xl mb-4'>{t("Depenses")}</h1>
      <ShowExpenses />
    </div>
  )
}

export default Expenses
